export interface TokenResponse {
  access_token: string;
  expires_at: string;
}

async function parseError(res: Response): Promise<Error> {
  try {
    const body = await res.json();
    return new Error(body.error ?? res.statusText);
  } catch {
    return new Error(res.statusText);
  }
}

export async function cookieLogin(email: string, password: string): Promise<TokenResponse> {
  const res = await fetch("/auth/cookie/login", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) throw await parseError(res);
  return res.json();
}

export async function cookieRefresh(): Promise<TokenResponse | null> {
  const res = await fetch("/auth/cookie/refresh", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
  });
  if (res.status === 204) return null;
  if (!res.ok) return null;
  return res.json();
}

export async function cookieLogout(accessToken?: string | null): Promise<void> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  await fetch("/auth/cookie/logout", {
    method: "POST",
    credentials: "include",
    headers,
  }).catch(() => {
    // best effort only
  });
}
